import React from 'react'
import ApartmentOnboarding from '../feature/ApartmentOnboarding/ApartmentOnboarding'


const ApartmentOnboardingPage = () => {
  return <>

      <ApartmentOnboarding />
  
  </>
}

export default ApartmentOnboardingPage